class ReservatioinCondition {
  constructor(el) {
    this.dom = {el:el}
    this.dom.trigger = this.dom.el.querySelector('[data-js="reservation-trigger"]');
    this.dom.reservation = document.querySelector('#reservation');

    this.dom.form = this.dom.el.querySelector('[data-js="reservation-form"]');
    this.dom.closer = this.dom.el.querySelectorAll('[data-js="reservation-closer"]');
    this.dom.arrival = this.dom.el.querySelector('[data-js="reservation-arrival"]');
    this.dom.departure = this.dom.el.querySelector('[data-js="reservation-departure"]');
    this.dom.adults = this.dom.el.querySelector('[data-js="reservation-adults"]');
    this.dom.children = this.dom.el.querySelector('[data-js="reservation-children"]');
    this.dom.guestsPlus = this.dom.el.querySelectorAll('[data-js="reservation-guests-plus"]');
    this.dom.guestsMinus = this.dom.el.querySelectorAll('[data-js="reservation-guests-minus"]');
    this.dom.search = null;

    this.dom.calendar = this.dom.el.querySelector('[data-js="calendar"]');
    this.dom.calendarMonth = this.dom.calendar.querySelector('[data-js="calendar-month"]');
    this.dom.calendarPrev = this.dom.calendar.querySelector('[data-js="calendar-controller-prev"]');
    this.dom.calendarNext = this.dom.calendar.querySelector('[data-js="calendar-controller-next"]');

    this.isReservationOpen = false;

    this.device = null;
    this.between = false; // 宿泊期間を塗るためのフラグ
    this.currentY = null; // カレンダー表示中の年
    this.currentM = null; // カレンダー表示中の月
    this.currentD = null;
    this.arrivalY = null;	// チェックインする年
    this.arrivalM = null; // チェックインする月
    this.arrivalD = null; // チェックインする日
    this.arrivalFormat = false; // チェックイン日のフォーマット
    this.arrivalFlug = false; // チェックインフラグ
    this.departureY = null; // チェックアウトする年
    this.departureM = null; // チェックアウトする月
    this.departureD = null; // チェックアウトする日
    this.departureFormat = false; // チェックアウト日のフォーマット
    this.departureFlug = false; // チェックアウトフラグ
    this.setFlag = false;
    this.numAdults = 1;
    this.numChildren = 0;
    // this.apiUrl = 'https://asp.hotel-story.ne.jp/ver3d/planlist.asp';
    this.apiUrl = '';
    this.hotelID = {
      'jp': '89240',
      'en': '89241'
    },
    this.holiday = null;
    this.formatHoliday = [];
    this.holidayCSV = '/assets/csv/syukujitsu.csv'; // http://www8.cao.go.jp/chosei/shukujitsu/syukujitsu.csv
    this.init();
  }

  init() {
    /**
     * メイン処理 : 現在日とその前後で3ヶ月分のカレンダーを生成する
     */
    // 今月のカレンダーを作る
    // 現在日付
    const now = new Date();
    this.currentY = now.getFullYear();
    this.currentM = now.getMonth();
    this.setHoliday();

    // 予約メニューの表示    
    this.dom.trigger.addEventListener('click', (e) => {
      this.toggleReservation();
      if (!e.currentTarget.dataset.is) {
        e.currentTarget.dataset.is = 'search';
      } else {
        e.currentTarget.removeAttribute('data-is');
        e.preventDefault();
        const type = e.currentTarget.dataset.type;
        const ID = (type !== 'en') ? this.hotelID.jp : this.hotelID.en;
        const arrival = this.arrivalY + '/' + this.arrivalM + '/' + this.arrivalD;
        const departure = this.departureY + '/' + this.departureM + '/' + this.departureD;
        const adults = this.numAdults;
        const children = this.numChildren;
        console.log({arrival})
        const setUrl = `${this.apiUrl}?tripla_booking_widget_open=search&checkin=${arrival}&checkout=${departure}&adults=${adults}&kids_tiers=[{"code":"A","children":${children}},{"code":"B","children":0},{"code":"B2","children":0},{"code":"C","children":0},{"code":"D","children":0}]`;
        console.log(arrival === 'null/null/null')
        if (arrival !== 'null/null/null' && departure !== 'null/null/null') {
          setTimeout(() => {
            window.open(setUrl, '_self');
          }, 900);
        }
      }
    });

    // 前の月カレンダーに切り替え
    this.dom.calendarPrev.addEventListener('click', () => {
      this.dom.calendarMonth.textContent = '';
      this.dateChangePrev();
    });

    // 次の月カレンダーに切り替え
    this.dom.calendarNext.addEventListener('click', () => {
      this.dom.calendarMonth.textContent = '';
      this.dateChangeNext();
    });

    // 人数を増やす
    [...this.dom.guestsPlus].forEach(el => {
      el.addEventListener('click', (e) => {
        const type = e.currentTarget.dataset.type;
        this.setNumPlus(type);
      });
    });

    // 人数を減らす
    [...this.dom.guestsMinus].forEach(el => {
      el.addEventListener('click', (e) => {
        const type = e.currentTarget.dataset.type;
        this.setNumMinus(type);
      });
    });

    // 閉じるボタン
    [...this.dom.closer].forEach(el => {
      el.addEventListener('click', () => {
        this.toggleReservation();
        this.dom.trigger.removeAttribute('data-is');
      });
    })

    // 検索結果表示ボタン（画面遷移）
    // this.dom.search.addEventListener('click', (e) => {
    //   e.preventDefault();
    //   const type = e.currentTarget.dataset.type;
    //   const ID = (type !== 'en') ? this.hotelID.jp : this.hotelID.en;
    //   const arrival = this.arrivalY + '/' + this.arrivalM + '/' + this.arrivalD;
    //   const departure = this.departureY + '/' + this.departureM + '/' + this.departureD;
    //   const adults = this.numAdults;
    //   const children = this.numChildren;
    //   // const setUrl = this.apiUrl + '?hcod1=' + ID + '&hcod2=001&hidmode=select&mode=seek&hidSELECTARRYMD=' + arrival + '&hidSELECTHAKSU=' + this.getDiff( arrival, departure ) + '&room=0&hidSELECTadult=' + adults + '&hidSELECTchilda=' + children + '&hidSELECTchildb=0&hidSELECTchildc=0&hidSELECTchildd=0&hidSELECTminPrice=0&hidSELECTmaxPrice=9999999&Dispunit=&chkymd=0&chkpsn=0';
    //   const setUrl = `${this.apiUrl}?tripla_booking_widget_open=search&checkin=${arrival}&checkout=${departure}&adults=${adults}&kids_tiers=[{"code":"A","children":${children}},{"code":"B","children":0},{"code":"B2","children":0},{"code":"C","children":0},{"code":"D","children":0}]`;
    //   window.open(setUrl, '_self');
    // });
  }

  toggleReservation() {
    if (this.isReservationOpen) {
      this.dom.trigger.setAttribute('aria-expanded', false);
      this.dom.reservation.setAttribute('aria-hidden', true);
      this.scrollEnable();
    } else {
      this.dom.trigger.setAttribute('aria-expanded', true);
      this.dom.reservation.setAttribute('aria-hidden', false);
      this.isMenuOpen = false;
      this.scrollDisable();
    }

    if (document.body.dataset.isReservation === 'true') {
      document.body.removeAttribute('data-is-reservation');
    } else {
      document.body.dataset.isReservation = 'true';
      // document.body.removeAttribute('data-is-menu');
    }

    this.isReservationOpen = !this.isReservationOpen;
  }

  scrollDisable() {
    document.body.dataset.isScrolldisable = 'true';
	}

	scrollEnable() {
    document.body.removeAttribute('data-is-scrolldisable');
	}

  setPeriodClickEvent() {
    const days = this.dom.calendarMonth.querySelectorAll('span');
    [...days].forEach(day=>{
      day.addEventListener('click', (e) => {
        let day = e.currentTarget.innerText;
        if (!this.setFlag || this.arrivalD !== day) {
          this.dateSet(day);
        }
      });
    });
  }

  setHoliday() {
    const _this = this;
    this.holiday = new XMLHttpRequest();
    this.holiday.open('get', _this.holidayCSV, true);
    this.holiday.send(null);
    this.holiday.onload = () => {
      // 日付フォーマット用
      let dateFormat = {
        _fmt: {
          'yyyy': (date) => { return date.getFullYear() + ''; },
          'MM': (date) => { return ('0' + (date.getMonth() + 1)).slice(-2); },
          'dd': (date) => { return ('0' + date.getDate()).slice(-2); },
          'hh': (date) => { return ('0' + date.getHours()).slice(-2); },
          'mm': (date) => { return ('0' + date.getMinutes()).slice(-2); },
          'ss': (date) => { return ('0' + date.getSeconds()).slice(-2); }
        },
        _priority: ['yyyy', 'MM', 'dd', 'hh', 'mm', 'ss'],
        format: function(date, format) {
          return this._priority.reduce((res, fmt) => res.replace(fmt, this._fmt[fmt](date)), format)
        }
      };
      let dataArr = [];
      let tmp = _this.holiday.responseText.split('\n');
      for (let i = 1; i < tmp.length; i++) {
        dataArr = tmp[i].split(',');
        _this.formatHoliday.push(dateFormat.format(new Date( dataArr[0] ), 'yyyy-MM-dd'));
      };
      _this.calendarDraw(_this.currentY, _this.currentM);
    };
  }
  
  checkHoliday(str, date, callback) {
    let data = [];
    let addZero = (n) => {
      return ('0' + n).slice(-2);
    }
    let nDate = new Date(date);
    let dataArr = [];
    let checkDate = nDate.getFullYear() + '-' + addZero(nDate.getMonth() + 1) + '-' + addZero(nDate.getDate());
    let isHoliday = false;
    for (let i = 1; i <= this.formatHoliday.length; i++) {
      if (this.formatHoliday[i] === checkDate) {
        isHoliday = true;
        break;
      }
    };
    callback(isHoliday);
  }
  
  createMonthCalendarObj(year, month) {
    /**
     * 月のカレンダーとなる配列を作る
     *
     * @param year YYYY 形式
     * @param month 1月は 0 と表現
     * @return 年・月情報と月のカレンダーとなる配列を持ったオブジェクト
     *   ex. {
     *     year: 2018,
     *     month: 0,
     *     calendar: [
     *       [ '',  1,  2,  3,  4,  5,  6 ],
     *       [  7,  8,  9, 10, 11, 12, 13 ],
     *       ...
     *     ]
     *   }
     */

    let nowFlag;
    let aFlag;
    let dFlag;

    // チェックイン日
    const aY = this.arrivalY;
    const aM = this.arrivalM;
    const aD = this.arrivalD;

    // チェックアウト日
    const dY = this.departureY;
    const dM = this.departureM;
    const dD = this.departureD;

    // 現在の日付
    const now = new Date();
    const nowY = now.getFullYear();
    const nowM = now.getMonth();
    const nowD = now.getDate();
    let nowFormat = nowY + '/' + (nowM + 1) + '/' + nowD;

    // カウントアップする日付
    let date = 1;

    // 開始日
    const begin = new Date(year, month, 1);
    const beginYear = begin.getFullYear();
    const beginMonth = begin.getMonth();
    const beginDay = (begin.getDay() === 0) ? 6 : begin.getDay() - 1;

    // 当月の月末日 : 翌月0日にすると当月末日が拾える
    const end     = new Date( year, month + 1, 0);
    const endDate = end.getDate();
    const endDay  = (end.getDay() === 0) ? 6 : end.getDay() - 1;

    nowFlag = (nowY === beginYear && nowM === beginMonth) ? true : false;
    aFlag = (aY === beginYear && aM === (beginMonth + 1)) ? true : false;
    dFlag = (dY === beginYear && dM === (beginMonth + 1)) ? true : false;
    
    // 1ヶ月分の配列 : 週ごとに子配列を持つ
    const calendar = [];
    for (let row = 0; row < 6; row++) {
      // 月の最終日を超えたループはしない (行を生成しない)
      if (date > endDate) continue;

      // 1週間分の配列
      const week = [];
      let todayFlag = false;

      for (let col = 0; col < 7; col++) {
        if (row === 0 && col < beginDay) {
          // 1行目で、1日目の曜日より前なら、前月の日付を入れる (当月開始日 - 1 - 曜日分の負数)
          const beforeDate = new Date(beginYear, beginMonth, -(beginDay - 1 - col)).getDate();
          week.push(beforeDate);
        }
        else if ( date > endDate ) {
          // 月の最終日を超えていれば、翌月の日付を入れる (当月最終日 + 曜日分のオフセット)
          const afterDate = new Date( beginYear, beginMonth, ( endDate + col - endDay ) ).getDate();
          week.push(afterDate);
        }
        else {
          let holidayClass = null;
          let beginFormat = beginYear + '/' + (beginMonth + 1) + '/' + date;
          let checkDate = year + '-' + (month + 1) + '-' + date;
          this.checkHoliday(this.holiday.responseText, year + '/' + (month + 1) + '/' + date, (result) => {
            holidayClass = (result) ? ' is-holiday' : '';
          });

          // 通常の場合は当日日付を入れインクリメントする
          if (this.setFlag && this.getDiff(this.arrivalFormat, beginFormat) < 0) {
            week.push('<span class="is-disable' + holidayClass + '">' + date + '</span>');
          }
          else if ( nowFlag && nowD === date ) {
            // 今日
            todayFlag = true;
            week.push('<span class="is-today' + holidayClass + '">' + date + '</span>');
          }
          else if ( aFlag && aD == date ) {
            // チェックイン日
            week.push('<span class="is-active' + holidayClass + '">' + date + '</span>');
          }
          else if ( dFlag && dD == date ) {
            // チェックアウト日
            week.push('<span class="is-active' + holidayClass + '">' + date + '</span>');
          }
          else if (!this.setFlag && this.getDiff(this.arrivalFormat, beginFormat) > 0 && this.getDiff(this.departureFormat, beginFormat) < 0) {
            week.push('<span class="is-active' + holidayClass + '">' + date + '</span>');
          }
          else {
            if (!todayFlag && this.getDiff(now, beginFormat) < 0) {
              week.push('<span class="is-disable">' + date + '</span>');
            } else {
              week.push('<span class="is-weekday' + holidayClass + '">' + date + '</span>');
            }
          }
          date++;
        }
      }
      calendar.push(week);
    }

    // データを連想配列にして返す
    const monthCalendar = {
      year: beginYear,
      month: beginMonth,
      calendar: calendar
    };

    return monthCalendar;
  }
  
  drawMonthCalendar(monthCalendarObj, targetElem) {
    /**
      * 月カレンダーを描画する
      *
      * @param monthCalendarObj 年・月情報と月のカレンダーとなる配列を持ったオブジェクト
      * @param targetElem カレンダーを挿入する要素
      */
    const year = monthCalendarObj.year;
    const month = monthCalendarObj.month;
    const calendar = monthCalendarObj.calendar;

    const now = new Date();
    const nowY = now.getFullYear();
    const nowM = now.getMonth();

    // table 要素を作る
    const weekArray = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const table = document.createElement('table');
    table.classList.add('g-calendar-table');
    const tableCaption = document.createElement('caption');
    const tableThead = document.createElement('thead');
    const tableTr = document.createElement('tr');
    const tableTbody = document.createElement('tbody');

    let tableThArray = [];
    [...weekArray].forEach((w, i) => {
      tableThArray[i] = document.createElement('th');
      tableThArray[i].textContent = weekArray[i];
      tableTr.appendChild(tableThArray[i]);
    });

    tableThead.appendChild(tableTr);
    table.appendChild(tableCaption);
    table.appendChild(tableThead);
    table.appendChild(tableTbody);

    // キャプション: 和暦を併記する
    let enYear = new Date(year, month).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    const pattern = '/{2,}/';
    enYear = '<span class="g-calendar-table__month">' + enYear.replace(/ /gi, '</span><span class="g-calendar-table__year">') + '</span>';
    tableCaption.innerHTML = enYear;

    calendar.forEach((week, rowIndex) => {
      const row = document.createElement('tr');
      week.forEach((day, colIndex) => {
        const col = document.createElement('td');
        col.innerHTML = day;
        // 曜日クラスを付与する
        if (colIndex >= 5) {
          col.dataset.is = (colIndex === 5) ? 'sat' : 'sun';
        }

        // 1行目で「7」より大きい日付が入った場合は前月の日付
        const isBeforeDate = rowIndex === 0 && day > 7;

        // 3行目以降で「7」より小さい日付が入った場合は翌月の日付
        const isAfterDate  = rowIndex > 1 && day < 7;
        
        // 前月・翌月は色付けする
        if (isBeforeDate || isAfterDate) {
          col.dataset.day = 'past';
        }

        row.append(col);
      });

      tableTbody.appendChild(row);
    } );

    targetElem.appendChild(table);
  }
  
  calendarDraw(_y, _m) {
    this.drawMonthCalendar(this.createMonthCalendarObj(_y, _m), this.dom.calendarMonth);
    // 先月、翌月の日付を非表示に
    const outDate = document.querySelectorAll('[data-day="past"]');
    [...outDate].forEach(day => {
      day.textContent = '';
    })
    this.setPeriodClickEvent();
  }
  
  calendarReDraw() {
    this.calendarDraw(this.currentY, this.currentM);
  }

  dateChangePrev() {
    this.currentY = (this.currentM - 1 < 0) ? this.currentY - 1 : this.currentY;
    this.currentM = (this.currentM - 1 < 0) ? 11 : this.currentM - 1;
    this.calendarDraw(this.currentY, this.currentM);
  }
  
  dateChangeNext() {
    this.currentY = (this.currentM + 1 > 11) ? this.currentY + 1 : this.currentY;
    this.currentM = (this.currentM + 1 > 11) ? 0 : this.currentM + 1;
    this.calendarDraw(this.currentY, this.currentM);
  }
  
  dateSet(_d) {
    const date = this.currentY + ' / ' + (this.currentM + 1) + ' / ' + _d;
    this.setFlag = !this.setFlag;
    if (this.setFlag) {
      this.dateReset();
      this.arrivalY = this.currentY;
      this.arrivalM = this.currentM + 1;
      this.arrivalD = this.currentD = _d;
      this.arrivalFormat = this.arrivalY + '/' + this.arrivalM + '/' + this.arrivalD;
      this.dom.arrival.innerHTML = date.replace(/\//gi, '<span>/</span>');
    } else {
      this.departureY = this.currentY;
      this.departureM = this.currentM + 1;
      this.departureD = this.currentD = _d;
      this.departureFormat = this.departureY + '/' + this.departureM + '/' + this.departureD;
      this.dom.departure.innerHTML = date.replace(/\//gi, '<span>/</span>');
    }

    this.dom.calendarMonth.textContent = '';
    this.calendarReDraw();
  }

  dateReset() {
    this.arrivalY = null;
    this.arrivalM = null;
    this.arrivalD = this.currentD = null;
    this.arrivalFormat = null;
    this.departureY = null;
    this.departureM = null;
    this.departureD = this.currentD = null;
    this.departureFormat = null;
    this.dom.arrival.textContent = '—— / — / —';
    this.dom.departure.textContent = '—— / — / —';
    this.dom.calendarMonth.textContent = '';
    this.calendarReDraw();
  }

  setNumPlus(_t) {
    if (_t === 'adults') {
      this.numAdults++;
      this.dom.adults.textContent = this.numAdults;
    } else {
      this.numChildren++;
      this.dom.children.textContent = this.numChildren;
    }
  }

  setNumMinus(_t) {
    if (_t === 'adults') {
      this.numAdults = (this.numAdults - 1 <= 0) ? 0 : this.numAdults - 1;
      this.dom.adults.textContent = this.numAdults;
    } else {
      this.numChildren = (this.numChildren - 1 <= 0) ? 0 : this.numChildren - 1;
      this.dom.children.textContent = (this.numChildren === 0) ? '—' : this.numChildren;
    }
  }

  /*
   * 日付の差分日数を返却します。
   */
  getDiff(date1Str, date2Str) {
    const date1 = new Date(date1Str);
    const date2 = new Date(date2Str);

    // getTimeメソッドで経過ミリ秒を取得し、２つの日付の差を求める
    const msDiff = date2.getTime() - date1.getTime();

    // 求めた差分（ミリ秒）を日付へ変換します（経過ミリ秒÷(1000ミリ秒×60秒×60分×24時間)。端数切り捨て）
    const daysDiff = Math.floor(msDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  }
}

export default ReservatioinCondition